export default "__VITE_ASSET__DTHH3yVD__"